import React from 'react';
// import { Anchor, Button } from 'antd';
// import { DownCircleFilled } from '@ant-design/icons';

import Header from '../components/Header';
import AboutAd from '../components/AboutAd';
import PressRelease from '../components/PressRelase';
import ContentWrapperUI from '../components/ContentWrapperUI';

import '../styles/Event.css';

const videoArray = [
  {
    key: '01',
    background : 'linear-gradient(180deg, #FFF 26.6%, #f5f4f5 26.6%)'
  },
  {
    key: '02',
    background : '#ffffff'
  },
  {
    key: '03',
    background : '#f5f4f5'
  },

]

const Event = props => (
  <div className="event-wrapper">
    <div className="anchor-wrapper">
      <img src={require('../img/startup-bulkup-event/cta-button.png')}  alt="event-link-btn" id="event-go-form" className="go-event-btn" width={400}
        onClick={() => newTab('https://bit.ly/ADsticker_event_form2')}
      />
      {/* <Anchor affix={false}>
        <Anchor.Link href="#go-event" title={
          <Button ghost className="go-event-anchor"> 
            <DownCircleFilled className="go-event-anchor-icon"/> 
            <p>이벤트 신청하러 가기</p>
          </Button>
        }/>
      </Anchor> */}
    </div>
    <Header defaultLanguage="ko" background="#262490"/>
    <div className="event-main">
      <img src={require('../img/startup-bulkup-event/campaign-main.png')} height={480} alt="event-main"/>
    </div>
    <div className="event event-01">
      <img src={require('../img/startup-bulkup-event/about-adsticker-ko@2x.png')} width={1024} alt="startup-marketing-project-title"/>
    </div>
    <div style={{background:'#46d28a'}}>
      <img src={require('../img/startup-bulkup-event/example.png')} width={1024} alt="startup-marketing-project-title"/>
    </div>
    <div className="event event-02">
      <div className="event-02-box">
        <img src={require('../img/startup-bulkup-event/button@2x.png')}  alt="event-link-btn" id="go-event" className="event-link-btn" width={522}
        onClick={() => newTab('https://bit.ly/ADsticker_event_form')}
        />
        <img src={require('../img/startup-bulkup-event/button-marketing@2x.png')}  alt="event-marketing-link-btn" className="event-marketing-link-btn" width={440}
        onClick={() => newTab('https://bit.ly/ADsticker_ref')}
          />
      </div>
    </div>
    <div>
      <img src={require('../img/startup-bulkup-event/about-adsticker-marketing.png')} height={160}/>
    </div>
    <AboutAd/>
    <ContentWrapperUI 
      component={<PressRelease/>}
      paddingStyle={{padding: '0px 87px'}}
    /> 
    <div className="event-footer"/>
  </div>
) 

const newTab = (url) => {
  window.open(url, '_blank')
}


export default Event;
